import React, { useState, useEffect } from 'react';
import * as newsService from "../services/newsService";
import SunEditor, { buttonList } from 'suneditor-react';
import { Calendar } from 'primereact/calendar';
import { FormatDateBG } from '../../utils/RegisterApplicationBodyFormatter';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import Swal from 'sweetalert2'
export function AdminAddMainPageNews() {
    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState({
        title: '',
        data : null,
        news: '',
    });

    const [newsHtml, setNewsHtml] = useState('');

    document.title = `Новина начална страница`;

    const handleContentChange = (e) => {
        if (e.target) {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
        } else {
            setNewsHtml(e);
        }
    };

    const onClickHeandler = (val) => {

        if (formData.title === '') { Swal.fire({ title: "Внимание", text: 'Моля въведете заглавие на новината!', icon: "error" }); return; }
        if (!formData.data) { Swal.fire({ title: "Внимание", text: 'Моля въведете дата за новината!', icon: "error" }); return; }
        if (formData.news === '') { Swal.fire({ title: "Внимание", text: 'Моля въведете съдържание на новината!', icon: "error" }); return; }

        const body = {
            title: formData.title,
            news: newsHtml,
            data: FormatDateBG(formData.data),
            category_id: 0,
            forHomePage: true,
        }

        const updateNews = async () => {

           

            try {
                setShow(false);
                if (formData.id_news) {
                    newsService.update(formData.id_news, body)
                        .then((res) => {
                            Swal.fire({ title: "Успешно обновяване!", text: "", icon: "success" });
                            setShow(true);
                        })
                } else {
                    newsService.create(body)
                        .then((res) => {
                            Swal.fire({ title: "Успешно обновяване!", text: "", icon: "success" });
                            setShow(true);
                        })
                }

            } catch (error) {
                Swal.fire({ title: "Грешка при обновяване!", text: error.message, icon: "error" });
            }
        }

        updateNews();
    }

    useEffect(() => {
        const populateHome = async () => {
            try {
                newsService.getMainNews()
                    .then((res) => {
                        let data = res.data?.split('-');
                        setFormData(prevState => ({
                            "id_news": res.id_news,
                            "title": res.title,
                            "data": res.data ? new Date(data[2], data[1] - 1, data[0]) : null,
                            "category_id": 3,
                            "forHomePage": true,

                        }))
                        setNewsHtml(res.news)
                        setShow(true);
                    })
            } catch (error) { console.error('Error fetching data:', error.message); }
        };

        populateHome();
    }, []);

    return (
        <main id="main" className="main ">

            <div className="pagetitle">
                <h1 className="use-font">Новина за начална страница</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Добавяне - Редакция </li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard " >

                <div className="row h-100">

                    <div className="col-lg-12">
                        <div className="row news_bg h-100">
                            <div className="h-100">


                                {show &&
                                    <div className="h-100">
                                        <form>
                                            <div className="w-100">
                                                Заглавие:<br />
                                                <input type="text" id="title" name="title" value={formData.title} onChange={handleContentChange} className="w-100" />
                                            </div>
                                            {/*<div className="mb-3">*/}
                                            {/*    Дата:<br /><input type="text" id="data" name="data" value={formData.data} onChange={handleContentChange} />*/}
                                            {/*</div>*/}
                                            <div className="mb-3 mt-2">
                                                <Calendar
                                                    showButtonBar
                                                    locale='bg'
                                                    className="prime-dropdown-heigth"
                                                    name="data"
                                                    value={formData.data ? formData.data : null}
                                                    onChange={handleContentChange}
                                                    showIcon
                                                />
                                            </div>


                                            <SunEditor
                                                lang="en"
                                                autoFocus={true}
                                                name="html-editor"
                                                setOptions={{
                                                    height: '65vh',
                                                    buttonList: [
                                                        ['undo', 'redo'],
                                                        ['font', 'fontSize', 'formatBlock'],
                                                        ['paragraphStyle', 'blockquote'],
                                                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                                        ['fontColor', 'hiliteColor', 'textStyle'],
                                                        ['removeFormat'],
                                                        ['outdent', 'indent'],
                                                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                        ['table', 'link', 'image', /** 'video', 'audio'  ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
                                                        /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
                                                        ['showBlocks', 'codeView'],
                                                        ['preview', 'print'],
                                                    ]
                                                }} // Initialize with HTML content
                                                setContents={newsHtml}
                                                onChange={handleContentChange} // Handle content change
                                            />
                                            <div className="text-center">
                                                <button type="button" className="btn btn-primary mt-3 mb-3" onClick={() => onClickHeandler()} >{formData.id_news ? 'Редакция' : 'Добави'}</button>
                                            </div>
                                        </form>
                                    </div>
                                }


                            </div>
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminAddMainPageNews;

